webpackJsonp([3],{

/***/ 257:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(10);
	
	var _gatsbyHelpers = __webpack_require__(13);
	
	var _SiteMargin = __webpack_require__(30);
	
	var _SiteMargin2 = _interopRequireDefault(_SiteMargin);
	
	var _colors = __webpack_require__(12);
	
	var _glamor = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var foci = [{
	  headlineText: Glamor.createElement(
	    'span',
	    null,
	    'User-',
	    Glamor.createElement('br', null),
	    'Centric',
	    Glamor.createElement('br', null),
	    'Design'
	  ),
	  supportText: "Simple, intuitive interfaces drive successful outcomes. Whether you're building the next Uber, lifestyle blog, or pizza-ordering app, we make sure users find the experience fresh and easy. "
	}, {
	  headlineText: Glamor.createElement(
	    'span',
	    null,
	    'Data',
	    Glamor.createElement('br', null),
	    'Is',
	    Glamor.createElement('br', null),
	    'King'
	  ),
	  supportText: "You've got the smarts to edge out the competition, we'll make sure you have the data you need to crunch the numbers. We track page views, interactions, and conversions so you know what's working and what's not."
	}, {
	  headlineText: Glamor.createElement(
	    'span',
	    null,
	    'Fast',
	    Glamor.createElement('br', null),
	    '&',
	    Glamor.createElement('br', null),
	    'Solid'
	  ),
	  supportText: "Loading spinners and buggy interfaces push away customers. We're better than that. Our sites and apps load quickly and function worry-free."
	}];
	
	var lineItem = function lineItem(_ref) {
	  var headlineText = _ref.headlineText,
	      supportText = _ref.supportText,
	      key = _ref.key;
	  return Glamor.createElement(
	    'div',
	    {
	      key: key,
	      css: [{
	        display: 'flex',
	        flexDirection: 'column',
	        background: _colors.colors.snow,
	        minHeight: (0, _typography.rhythm)(6),
	        alignItems: 'center',
	        padding: (0, _typography.rhythm)(1) + ' ' + (0, _typography.rhythm)(2),
	        borderBottom: key === foci.length - 1 ? 0 : '1px solid ' + _colors.colors.charcoalBlue
	      }, (0, _glamor.media)(_glamor.presets.tablet, {
	        flexDirection: 'row'
	      })]
	    },
	    Glamor.createElement(
	      'div',
	      {
	        css: [{
	          fontSize: (0, _typography.rhythm)(3 / 2),
	          lineHeight: (0, _typography.rhythm)(3 / 2),
	          marginBottom: (0, _typography.rhythm)(1),
	          textAlign: 'center',
	          minWidth: (0, _typography.rhythm)(5)
	        }, (0, _glamor.media)(_glamor.presets.tablet, {
	          marginRight: (0, _typography.rhythm)(1),
	          textAlign: 'left'
	        })]
	      },
	      headlineText
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: [{
	          padding: (0, _typography.rhythm)(1) + ' 0',
	          textAlign: 'center',
	          borderTop: '1px solid ' + _colors.colors.almond
	        }, (0, _glamor.media)(_glamor.presets.tablet, {
	          borderLeft: '1px solid ' + _colors.colors.almond,
	          borderTop: 0,
	          padding: (0, _typography.rhythm)(2) + ' ' + (0, _typography.rhythm)(1),
	          textAlign: 'left'
	        })]
	      },
	      supportText
	    )
	  );
	};
	
	var Focus = function (_React$Component) {
	  _inherits(Focus, _React$Component);
	
	  function Focus() {
	    _classCallCheck(this, Focus);
	
	    return _possibleConstructorReturn(this, (Focus.__proto__ || Object.getPrototypeOf(Focus)).apply(this, arguments));
	  }
	
	  _createClass(Focus, [{
	    key: 'render',
	    value: function render() {
	      var focusElements = foci.map(function (focusItem, index) {
	        return lineItem({
	          headlineText: focusItem.headlineText,
	          supportText: focusItem.supportText,
	          key: index
	        });
	      });
	      return Glamor.createElement(
	        'div',
	        {
	          css: {
	            background: _colors.colors.darkPurple,
	            padding: (0, _typography.rhythm)(4) + ' ' + (0, _typography.rhythm)(1 / 2)
	          }
	        },
	        Glamor.createElement(
	          _SiteMargin2.default,
	          null,
	          Glamor.createElement(
	            'div',
	            {
	              css: {
	                display: 'flex',
	                flexDirection: 'column'
	              }
	            },
	            focusElements
	          )
	        )
	      );
	    }
	  }]);
	
	  return Focus;
	}(_react2.default.Component);
	
	Focus.propTypes = {};
	
	exports.default = Focus;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },

/***/ 258:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(10);
	
	var _gatsbyHelpers = __webpack_require__(13);
	
	var _SiteMargin = __webpack_require__(30);
	
	var _SiteMargin2 = _interopRequireDefault(_SiteMargin);
	
	var _colors = __webpack_require__(12);
	
	var _glamor = __webpack_require__(14);
	
	var _ContactModal = __webpack_require__(143);
	
	var _ContactModal2 = _interopRequireDefault(_ContactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Headline = function (_React$Component) {
	  _inherits(Headline, _React$Component);
	
	  function Headline() {
	    _classCallCheck(this, Headline);
	
	    return _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).apply(this, arguments));
	  }
	
	  _createClass(Headline, [{
	    key: 'render',
	    value: function render() {
	      return Glamor.createElement(
	        'div',
	        {
	          css: {
	            background: _colors.colors.darkPurple,
	            padding: (0, _typography.rhythm)(2) + ' ' + (0, _typography.rhythm)(1 / 2),
	            minHeight: '93vh'
	          }
	        },
	        Glamor.createElement(
	          _SiteMargin2.default,
	          null,
	          Glamor.createElement(
	            'div',
	            {
	              css: [{
	                display: 'flex',
	                flexDirection: 'column',
	                justifyContent: 'space-around',
	                alignItems: 'center',
	                color: _colors.colors.snow,
	                minHeight: '80vh'
	              }]
	            },
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  padding: (0, _typography.rhythm)(1),
	                  border: '1px solid ' + _colors.colors.charcoalBlue
	                }
	              },
	              Glamor.createElement(
	                'h1',
	                {
	                  css: [{
	                    fontSize: (0, _typography.rhythm)(2),
	                    lineHeight: (0, _typography.rhythm)(2),
	                    color: _colors.colors.snow
	                  }, (0, _glamor.media)(_glamor.presets.tablet, {
	                    fontSize: (0, _typography.rhythm)(5),
	                    lineHeight: (0, _typography.rhythm)(5)
	                  })]
	                },
	                'Let\'s ',
	                Glamor.createElement('br', null),
	                ' Build ',
	                Glamor.createElement('br', null),
	                ' Together'
	              ),
	              Glamor.createElement(_ContactModal2.default, {
	                text: 'Start the Conversation',
	                icon: true,
	                style: {
	                  background: _colors.colors.snow,
	                  ':hover': {
	                    background: _colors.colors.almond
	                  },
	                  color: _colors.colors.weldonBlue,
	                  padding: (0, _typography.rhythm)(1 / 4) + ' ' + (0, _typography.rhythm)(1 / 2),
	                  marginLeft: (0, _typography.rhythm)(1 / 4),
	                  marginTop: (0, _typography.rhythm)(1),
	                  fontSize: (0, _typography.rhythm)(1 / 2)
	                },
	
	                mobileStyle: {
	                  padding: (0, _typography.rhythm)(1 / 2) + ' ' + (0, _typography.rhythm)(1),
	                  marginLeft: (0, _typography.rhythm)(1 / 2)
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Headline;
	}(_react2.default.Component);
	
	Headline.propTypes = {};
	
	exports.default = Headline;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },

/***/ 259:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(10);
	
	var _gatsbyHelpers = __webpack_require__(13);
	
	var _SiteMargin = __webpack_require__(30);
	
	var _SiteMargin2 = _interopRequireDefault(_SiteMargin);
	
	var _colors = __webpack_require__(12);
	
	var _glamor = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaMapO = __webpack_require__(536);
	var FaObjectGroup = __webpack_require__(537);
	var FaWrench = __webpack_require__(538);
	
	
	var processPoints = [{
	  headlineText: "Scope It.",
	  supportingText: "We'll chat about audience, goals, features, and timeline. We'll figure out a plan to fit your budget and accomplish your objective.",
	  icon: _react2.default.createElement(FaMapO, null)
	}, {
	  headlineText: "Design It.",
	  supportingText: "Our design team will collaborate with you and develop wireframes and then hi-fidelity mocks of the product. (You'll have a big grin on your face by this point).",
	  icon: _react2.default.createElement(FaObjectGroup, null)
	}, {
	  headlineText: "Build It.",
	  supportingText: "Once we've agreed on the design, our development team will build and test the product. We'll make sure everything is well documented for a streamlined handoff.",
	  icon: _react2.default.createElement(FaWrench, null)
	}];
	
	var lineItem = function lineItem(_ref) {
	  var headlineText = _ref.headlineText,
	      supportingText = _ref.supportingText,
	      icon = _ref.icon,
	      key = _ref.key;
	  return Glamor.createElement(
	    'div',
	    {
	      key: key,
	      css: [{
	        minWidth: '250px',
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        background: _colors.colors.snow,
	        borderBottom: '5px solid ' + _colors.colors.almond,
	        padding: (0, _typography.rhythm)(1 / 2),
	        marginBottom: (0, _typography.rhythm)(1)
	      }, (0, _glamor.media)(_glamor.presets.tablet, {
	        flexBasis: '33%'
	      })]
	    },
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          fontSize: (0, _typography.rhythm)(2),
	          textAlign: 'center',
	          color: _colors.colors.weldonBlue,
	          padding: (0, _typography.rhythm)(1 / 2),
	          borderRadius: '100',
	          background: _colors.colors.charcoalBlue,
	          marginTop: (0, _typography.rhythm)(1),
	          marginBottom: (0, _typography.rhythm)(1)
	        }
	      },
	      icon
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          fontSize: (0, _typography.rhythm)(3 / 2),
	          fontWeight: 'bold',
	          lineHeight: (0, _typography.rhythm)(3 / 2),
	          paddingBottom: (0, _typography.rhythm)(1 / 2),
	          borderBottom: '1px solid ' + _colors.colors.almond
	        }
	      },
	      headlineText
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          textAlign: 'center',
	          padding: (0, _typography.rhythm)(1)
	        }
	      },
	      supportingText
	    )
	  );
	};
	
	var Process = function (_React$Component) {
	  _inherits(Process, _React$Component);
	
	  function Process() {
	    _classCallCheck(this, Process);
	
	    return _possibleConstructorReturn(this, (Process.__proto__ || Object.getPrototypeOf(Process)).apply(this, arguments));
	  }
	
	  _createClass(Process, [{
	    key: 'render',
	    value: function render() {
	      var processElements = processPoints.map(function (processPoint, key) {
	        return lineItem(_extends({}, processPoint, {
	          key: key
	        }));
	      });
	      return Glamor.createElement(
	        'div',
	        {
	          css: {
	            background: _colors.colors.raisinBlack,
	            padding: (0, _typography.rhythm)(4) + ' ' + (0, _typography.rhythm)(1 / 2)
	          }
	        },
	        Glamor.createElement(
	          _SiteMargin2.default,
	          null,
	          Glamor.createElement(
	            'div',
	            {
	              css: [{
	                display: 'flex',
	                flexDirection: 'column',
	                justifyContent: 'space-around'
	              }, (0, _glamor.media)(_glamor.presets.tablet, {
	                flexDirection: 'row'
	              })]
	            },
	            processElements
	          )
	        )
	      );
	    }
	  }]);
	
	  return Process;
	}(_react2.default.Component);
	
	Process.propTypes = {};
	
	exports.default = Process;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },

/***/ 260:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(10);
	
	var _gatsbyHelpers = __webpack_require__(13);
	
	var _SiteMargin = __webpack_require__(30);
	
	var _SiteMargin2 = _interopRequireDefault(_SiteMargin);
	
	var _colors = __webpack_require__(12);
	
	var _glamor = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var team = [{
	  name: "Lindsay",
	  title: "Lead Designer",
	  description: "I make sure your product is intuitive and beautiful. I collaborate with you to arrive at a fresh, impressive user interface that delivers a top-notch user experience.",
	  photo: "http://res.cloudinary.com/krasa/image/upload/v1484009470/Lindsay_Clark_375x300_fjc2yg.jpg"
	}, {
	  name: "Abe",
	  title: "Lead Developer",
	  description: "I build your product using dependable, current web and app frameworks that ensure a fast and reliable experience. I deliver the data you crave and keep your customers' private information private.",
	  photo: "http://res.cloudinary.com/krasa/image/upload/v1484009469/Abe_Clark_375x300_r1gben.jpg"
	}];
	
	var lineItem = function lineItem(_ref) {
	  var name = _ref.name,
	      title = _ref.title,
	      description = _ref.description,
	      photo = _ref.photo;
	  return Glamor.createElement(
	    'div',
	    {
	      key: name,
	      css: [{
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        background: _colors.colors.snow,
	        borderTopRightRadius: '5%',
	        borderTopLeftRadius: '5%',
	        borderBottom: '5px solid ' + _colors.colors.almond,
	        marginBottom: (0, _typography.rhythm)(1 / 2)
	      }, (0, _glamor.media)(_glamor.presets.tablet, {
	        flexBasis: '49.5%'
	      })]
	    },
	    Glamor.createElement('img', {
	      src: photo,
	      css: {
	        width: '100%',
	        borderTopRightRadius: '5%',
	        borderTopLeftRadius: '5%'
	      }
	    }),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          fontSize: (0, _typography.rhythm)(3 / 2),
	          fontWeight: 'bold',
	          lineHeight: (0, _typography.rhythm)(3 / 2),
	          paddingBottom: (0, _typography.rhythm)(1 / 2),
	          borderBottom: '1px solid ' + _colors.colors.almond
	        }
	      },
	      name
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          marginTop: (0, _typography.rhythm)(1 / 2),
	          fontWeight: 'bold'
	        }
	      },
	      title
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          textAlign: 'center',
	          padding: (0, _typography.rhythm)(1)
	        }
	      },
	      description
	    )
	  );
	};
	
	var Team = function (_React$Component) {
	  _inherits(Team, _React$Component);
	
	  function Team() {
	    _classCallCheck(this, Team);
	
	    return _possibleConstructorReturn(this, (Team.__proto__ || Object.getPrototypeOf(Team)).apply(this, arguments));
	  }
	
	  _createClass(Team, [{
	    key: 'render',
	    value: function render() {
	      var teamElements = team.map(function (teamMember) {
	        return lineItem(_extends({}, teamMember));
	      });
	      return Glamor.createElement(
	        'div',
	        {
	          css: {
	            background: _colors.colors.darkPurple,
	            padding: (0, _typography.rhythm)(4) + ' ' + (0, _typography.rhythm)(1 / 2)
	          }
	        },
	        Glamor.createElement(
	          _SiteMargin2.default,
	          null,
	          Glamor.createElement(
	            'div',
	            {
	              css: [{
	                display: 'flex',
	                flexDirection: 'column',
	                justifyContent: 'space-between'
	              }, (0, _glamor.media)(_glamor.presets.tablet, {
	                flexDirection: 'row'
	              })]
	            },
	            teamElements
	          )
	        )
	      );
	    }
	  }]);
	
	  return Team;
	}(_react2.default.Component);
	
	Team.propTypes = {};
	
	exports.default = Team;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },

/***/ 536:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(28);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMapO = function FaMapO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.2 2.8q0.6 0.4 0.6 1.1v27.3q0 0.4-0.3 0.7t-0.5 0.4l-12.4 5q-0.5 0.2-1 0l-11.9-4.8-12 4.8q-0.2 0.1-0.5 0.1-0.3 0-0.7-0.2-0.5-0.4-0.5-1.1v-27.3q0-0.4 0.2-0.7t0.6-0.4l12.4-5q0.5-0.2 0.9 0l12 4.8 11.9-4.8q0.7-0.2 1.2 0.1z m-24.9 2.6v24.7l11.2 4.5v-24.7z m-11.8 4.3v24.6l10.5-4.2v-24.7z m34.8 20.6v-24.6l-10.6 4.2v24.7z' })
	        )
	    );
	};
	
	exports.default = FaMapO;
	module.exports = exports['default'];

/***/ },

/***/ 537:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(28);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaObjectGroup = function FaObjectGroup(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.8 10.1h-2.5v19.8h2.5v7.5h-7.5v-2.5h-24.8v2.5h-7.5v-7.5h2.5v-19.8h-2.5v-7.5h7.5v2.5h24.8v-2.5h7.5v7.5z m-5-5v2.5h2.5v-2.5h-2.5z m-32.3 0v2.5h2.5v-2.5h-2.5z m2.5 29.8v-2.5h-2.5v2.5h2.5z m27.3-2.5v-2.5h2.5v-19.8h-2.5v-2.5h-24.8v2.5h-2.5v19.8h2.5v2.5h24.8z m5 2.5v-2.5h-2.5v2.5h2.5z m-12.5-19.9h7.5v14.9h-17.4v-4.9h-7.4v-14.9h17.3v4.9z m-14.9 7.5h12.5v-10h-12.5v10z m19.9 5v-10h-5v7.5h-7.4v2.5h12.4z' })
	        )
	    );
	};
	
	exports.default = FaObjectGroup;
	module.exports = exports['default'];

/***/ },

/***/ 538:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(28);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWrench = function FaWrench(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.6 32.9q0-0.6-0.5-1t-1-0.5-1 0.5-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m14.3-9.4l-15.2 15.2q-0.8 0.8-2 0.8-1.1 0-2-0.8l-2.4-2.4q-0.8-0.8-0.8-2 0-1.2 0.8-2l15.2-15.2q0.9 2.1 2.6 3.8t3.8 2.6z m14.2-9.7q0 0.8-0.5 2.3-1.1 3-3.7 4.9t-5.8 1.9q-4.1 0-7-3t-3-7 3-7.1 7-2.9q1.3 0 2.8 0.3t2.4 1.1q0.3 0.2 0.3 0.6t-0.3 0.6l-6.6 3.8v5l4.3 2.4q0.1-0.1 1.8-1.1t3-1.8 1.6-0.8q0.3 0 0.5 0.2t0.2 0.6z' })
	        )
	    );
	};
	
	exports.default = FaWrench;
	module.exports = exports['default'];

/***/ },

/***/ 587:
/***/ function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ },

/***/ 588:
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(587);
	
	module.exports = function include(str, needle) {
	  if (needle === '') return true;
	  return makeString(str).indexOf(needle) !== -1;
	};


/***/ },

/***/ 264:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(57);
	
	var _get = __webpack_require__(67);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyHelpers = __webpack_require__(13);
	
	var _typography = __webpack_require__(10);
	
	var _include = __webpack_require__(588);
	
	var _include2 = _interopRequireDefault(_include);
	
	var _Separator = __webpack_require__(146);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _Focus = __webpack_require__(257);
	
	var _Focus2 = _interopRequireDefault(_Focus);
	
	var _Team = __webpack_require__(260);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _Process = __webpack_require__(259);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _InquiryForm = __webpack_require__(145);
	
	var _InquiryForm2 = _interopRequireDefault(_InquiryForm);
	
	var _BlogThumbnailContainer = __webpack_require__(142);
	
	var _BlogThumbnailContainer2 = _interopRequireDefault(_BlogThumbnailContainer);
	
	var _Header = __webpack_require__(83);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Headline = __webpack_require__(258);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import '../css/zenburn.css'
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, (BlogIndex.__proto__ || Object.getPrototypeOf(BlogIndex)).apply(this, arguments));
	  }
	
	  _createClass(BlogIndex, [{
	    key: 'render',
	    value: function render() {
	      var metadata = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	      var blogEntries = (0, _get2.default)(this, 'props.data.allMarkdown.edges');
	      return Glamor.createElement(
	        'div',
	        null,
	        Glamor.createElement(_reactHelmet2.default, {
	          title: metadata.title + ' | Web, Mobile & App Design + Development',
	          meta: [{ name: 'og:type', content: 'website' }, { name: 'og:image', content: metadata.photoURL }, { name: 'og:url', content: 'krasadev.com' }, { name: 'og:description', content: metadata.description }, { name: 'fb:app_id', content: metadata.fbAppID }]
	        }),
	        Glamor.createElement(_Header2.default, null),
	        Glamor.createElement(_Headline2.default, null),
	        Glamor.createElement(_Separator2.default, { text: 'Process' }),
	        Glamor.createElement(_Process2.default, null),
	        Glamor.createElement(_Separator2.default, { text: 'Focus' }),
	        Glamor.createElement(_Focus2.default, null),
	        Glamor.createElement(_Separator2.default, { text: 'Blog' }),
	        Glamor.createElement(_BlogThumbnailContainer2.default, { blogEntries: blogEntries }),
	        Glamor.createElement(_Separator2.default, { text: 'Team' }),
	        Glamor.createElement(_Team2.default, null),
	        Glamor.createElement(_InquiryForm2.default, null)
	      );
	    }
	  }]);
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	BlogIndex.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '\n{\n  site {\n    buildTime\n    siteMetadata {\n      title\n      homeCity\n      author\n      photoURL\n      description\n      fbAppID\n    }\n  }\n  allMarkdown(first: 2000) {\n    edges {\n      node {\n        path\n        frontmatter {\n          title\n          photoURL\n          previewText\n        }\n      }\n    }\n  }\n}\n';
	// <Products products={products} />
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }

});


// WEBPACK FOOTER //
// page-component---pages-index-js-5b6a7c3fe6bf34f6bdd1.js